var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 4,
    fill: "#0066B0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12342_24942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0625 15.125H7V15.9375H11.0625V15.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0625 12.6875H7V13.5H11.0625V12.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 11.0625H7.8125C7.59701 11.0625 7.39035 10.9769 7.23798 10.8245C7.0856 10.6722 7 10.4655 7 10.25V7.8125C7 7.59701 7.0856 7.39035 7.23798 7.23798C7.39035 7.0856 7.59701 7 7.8125 7H15.9375C16.153 7 16.3597 7.0856 16.512 7.23798C16.6644 7.39035 16.75 7.59701 16.75 7.8125V10.25C16.75 10.4655 16.6644 10.6722 16.512 10.8245C16.3597 10.9769 16.153 11.0625 15.9375 11.0625ZM7.8125 7.8125V10.25H15.9375V7.8125H7.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 16.75H13.5C13.2845 16.75 13.0778 16.6644 12.9255 16.512C12.7731 16.3597 12.6875 16.153 12.6875 15.9375V13.5C12.6875 13.2845 12.7731 13.0778 12.9255 12.9255C13.0778 12.7731 13.2845 12.6875 13.5 12.6875H15.9375C16.153 12.6875 16.3597 12.7731 16.512 12.9255C16.6644 13.0778 16.75 13.2845 16.75 13.5V15.9375C16.75 16.153 16.6644 16.3597 16.512 16.512C16.3597 16.6644 16.153 16.75 15.9375 16.75ZM13.5 13.5V15.9375H15.9375V13.5H13.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12342_24942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpBlue);
export default __webpack_public_path__ + "static/media/HelpBlue.c234eaf23eb1ddc6d00c890759a94d69.svg";
export { ForwardRef as ReactComponent };